/** The four routes into the platform, and the eight audiences. Every target is an existing route. */
export const ROUTES = [
  {
    slug: "discover",
    n: "01",
    title: "Discover Our History",
    blurb: "Kenya's football memory: every professional we can verify, every first, and the record nobody was paid to keep.",
    links: [
      ["The Hall of Fame Top 20", "/hall-of-fame/leaderboard"],
      ["Every player we can verify", "/hall-of-fame"],
      ["First to do it", "/firsts"],
      ["The women's game", "/womens-game"],
      ["News and stories", "/news"],
      ["Football development updates", "/updates"],
      ["Player valuations", "/valuations"],
    ],
  },
  {
    slug: "your-county",
    n: "02",
    title: "Explore Your County",
    blurb: "Eighteen key counties for the professional game, all forty-seven for grassroots — with the gaps, the costs and the opportunities in each. If you can see the site, you can bring the project.",
    links: [
      ["Tell us about an opportunity", "/apply"],
      ["County map", "/counties"],
      ["Compare two counties", "/compare"],
      ["Facilities and costs", "/facilities"],
      ["Court rollout before AFCON", "/court-rollout"],
      ["Grassroots health and fitness", "/health-and-fitness"],
      ["Sources and method", "/sources"],
    ],
  },
  {
    slug: "national-plan",
    n: "03",
    title: "See the National Plan",
    blurb: "What it costs, in what order, and what it returns — the model, the law and the numbers behind it.",
    links: [
      ["Recommended steps", "/plans"],
      ["The money", "/money"],
      ["The value case", "/value-case"],
      ["Football as an economy", "/football-economy"],
      ["Player trading model", "/trading"],
      ["Sports law and governance", "/about"],
    ],
  },
  {
    slug: "partner",
    n: "04",
    title: "Partner With the Movement",
    blurb: "Investment, sponsorship, technical partnership, information and expertise — priced, evidenced and published. Tell us about an opportunity in your county: it is a preliminary expression of interest, and nothing is promised.",
    links: [
      ["Tell us about an opportunity", "/apply"],
      ["County funding scenarios", "/county-scenarios"],
      ["How modular stadiums are costed", "/modular-stadiums"],
      ["Send us your research", "/apply"],
      ["Training and jobs", "/training-and-jobs"],
      ["Media enquiries and partnerships", "/contact"],
      ["Join the diaspora register", "/apply"],
      ["Sources and method", "/sources"],
      ["Key observations", "/observations"],
    ],
  },
];

export const ROLES = [
  { key: "player", label: "Player", action: ["See the archive you could be in", "/hall-of-fame"],
    links: [["All players", "/hall-of-fame"], ["Training and jobs", "/training-and-jobs"], ["Health and fitness", "/health-and-fitness"], ["Player valuations", "/valuations"]] },
  { key: "parent", label: "Parent", action: ["Find what exists in your county", "/counties"],
    links: [["County map", "/counties"], ["Facilities and grassroots", "/facilities"], ["Health and fitness", "/health-and-fitness"], ["Recommended steps", "/plans"]] },
  { key: "coach", label: "Coach or Referee", action: ["See the courses and roles", "/training-and-jobs"],
    links: [["Training and jobs", "/training-and-jobs"], ["Facilities and grassroots", "/facilities"], ["Sports law and governance", "/about"], ["Women in football", "/womens-game"]] },
  { key: "club", label: "Club or Academy", action: ["Submit your club or academy", "/apply"],
    links: [["Submit a proposal", "/apply"], ["Sports law and governance", "/about"], ["Facilities and costs", "/facilities"], ["Player trading model", "/trading"]] },
  { key: "county", label: "County or Community", action: ["Open your county dossier", "/counties"],
    links: [["County map", "/counties"], ["Compare two counties", "/compare"], ["Court rollout", "/court-rollout"], ["Facilities and costs", "/facilities"]] },
  { key: "investor", label: "Prospective Funding Partner", action: ["Build county funding scenarios", "/county-scenarios"],
    links: [["County funding scenarios", "/county-scenarios"], ["The value case", "/value-case"], ["The money", "/money"], ["Media enquiries and partnerships", "/contact"]] },
  { key: "diaspora", label: "Diaspora Member", action: ["See where expertise is needed", "/ecosystem"],
    links: [["The football ecosystem", "/ecosystem"], ["Tell us about an opportunity", "/apply"], ["Send us your research", "/apply"], ["Training and jobs", "/training-and-jobs"]] },
  { key: "press", label: "Journalist or Researcher", action: ["Read the sources and method", "/sources"],
    links: [["Sources and method", "/sources"], ["Key observations", "/observations"], ["FIFA world ranking", "/fifa-ranking"], ["News and stories", "/news"]] },
];
